export default __webpack_public_path__ + "static/media/sketching2.04dd9cae.jpg";